import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

const syncSummerSizingNotes = () => {
  document
    .querySelectorAll('.lov-product-sizing-note, .lov-size-information__copy')
    .forEach((note) => {
      const lines = [...note.querySelectorAll('span')];
      const mLine = lines.find((line) => line.textContent.trim().includes('Du trägst M? Wähle XS-S.'));
      if (!mLine) return;

      const xlLine = lines.find(
        (line) =>
          line.textContent.includes('XL-XXL ist bewusst') ||
          line.textContent.includes('Du trägst XL?')
      );

      if (xlLine) {
        xlLine.textContent = 'Du trägst XL? Wähle M-L.';
      } else {
        const newLine = document.createElement('span');
        newLine.textContent = 'Du trägst XL? Wähle M-L.';
        mLine.after(newLine);
      }
    });
};

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    syncSummerSizingNotes();
    requestAnimationFrame(syncSummerSizingNotes);
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    this.toggleAttribute('hidden', newInventory.hasAttribute('hidden'));
    morph(this, newInventory, { childrenOnly: true });
    requestAnimationFrame(syncSummerSizingNotes);
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}

document.addEventListener('shopify:section:load', syncSummerSizingNotes);
